import axios from 'axios'
import { installVarunaAuthHeader } from '@/infra/http/varunaAuthHeader'

// varuna への通信にログイン中の会員の ID トークンを付ける（会員 API の本人確認）
installVarunaAuthHeader(axios)
const Axios = {
  install: function (Vue, _options) {
    // axios.defaults.withCredentials = true
    // axios.defaults.xsrfHeaderName = "X-CSRF-Token"
    // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    Vue.prototype.$axios = axios
  }
}
export default Axios
